/* eslint-disable react-hooks/exhaustive-deps */
// /* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import MeQuery from "src/graphql/query/auth/me";
import { useLazyQuery } from "@apollo/client";
import { useDispatch } from "react-redux";
import { meHandler } from "src/store/reducers/meSlice";
import setAuthDataInLocalStorage from "src/utils/auth/LocalStorage";
import { enqueueSnackbar } from "notistack";

interface ILoggedInUser {
  id: string;
  designation: {
    paneltype: string;
  };
  mainSuperAdminId: string;
  accessToken: string;
  name: string;
  email: string;
  picture: string | null;
  number: string;
  pages: string;
  commentPages: string;
  pseudonym: string;
  username: string;
  stripe_id: string;
  verified: number;
  facebookId: string;
  plans: string;
  endDate: string;
  hasTrial: string;
  subscriptionId: string;
  currentCount: number;
  maxCount: number;
  currentDeletedCount: number;
  stripe_subscription_status: string;
  new_plan: string;
  new_plan_status: string;
  plan_change_effective_date: string | null;
  plan_change_type: string | null;
  customFeatures: any;
  billingOnly: boolean;
}

const useAuth = () => {
  const dispatch = useDispatch();

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const [
    MeResponse,
    { data: meQueryResult, error: meQueryError, loading: meQueryLoading },
  ] = useLazyQuery(MeQuery, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await MeResponse();
      } catch (error: any) {
        // 🌐 Handle Offline / Network Failure
        const isNetworkError =
          error.networkError ||
          error.message?.includes("Network request failed") ||
          error.message?.includes("ERR_INTERNET_DISCONNECTED") ||
          !navigator.onLine;

        if (isNetworkError) {
          console.warn(
            "Auth check failed due to network error. Checking local session.",
          );
          const storedMe = localStorage.getItem("ActiveUserdetail");
          const token = localStorage.getItem("accessToken");

          if (storedMe && token) {
            dispatch(meHandler(JSON.parse(storedMe)));
            setIsAuthenticated(true);
            setLoading(false);
            return;
          }
        }

        console.error("Auth fetch failed:", error);
        setLoading(false);
        setIsAuthenticated(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (meQueryResult && meQueryResult.me) {
      if (meQueryResult.me.status === "BLOCKED") {
        setIsAuthenticated(false);
        enqueueSnackbar("User is Blocked", {
          variant: "error",
        });
        return;
      }

      const storedMe = JSON.parse(
        localStorage.getItem("ActiveUserdetail") || "{}",
      );
      const billingOnly = storedMe.billingOnly || false;
      const mergedMe: ILoggedInUser = {
        ...meQueryResult.me,
        billingOnly,
      };

      setAuthDataInLocalStorage(mergedMe);
      dispatch(meHandler(mergedMe));
      setIsAuthenticated(true);
    }
    // ❌ Removed the 'else { setIsAuthenticated(false); }' block.
    // This block was triggering prematurely during offline refreshes,
    // causing a race condition that resulted in a redirect to login.
  }, [meQueryResult]);

  useEffect(() => {
    setLoading(meQueryLoading);
  }, [meQueryLoading]);

  useEffect(() => {
    if (meQueryError) {
      const isNetworkError =
        meQueryError.networkError ||
        meQueryError.message?.includes("Network request failed") ||
        !navigator.onLine;

      if (isNetworkError) {
        console.warn(
          "Auth-2 check failed due to network error. Checking local session.",
        );
        const storedMe = localStorage.getItem("ActiveUserdetail");
        if (storedMe) {
          dispatch(meHandler(JSON.parse(storedMe)));
          setIsAuthenticated(true);
          return;
        }
      }

      setIsAuthenticated(false);
    }
  }, [meQueryError]);

  return { loading, isAuthenticated };
};

export default useAuth;
